import { Button, Center, Stack } from '@mantine/core'
import { FormattedMessage } from 'react-intl'
import { PlatformAlert } from '@/components/ui-shared/PlatformAlert/PlatformAlert'

type PasswordResetLinkExpiredProps = {
  onResendEmail: () => void
}

export const PasswordResetLinkExpired = ({
  onResendEmail
}: PasswordResetLinkExpiredProps) => {
  return (
    <Stack gap="xl">
      <PlatformAlert variant="warning">
        <FormattedMessage id="passwordReset.linkExpired" />
      </PlatformAlert>

      <Center>
        <Button size="xs" onClick={onResendEmail}>
          <FormattedMessage id="passwordReset.resendEmail" />
        </Button>
      </Center>
    </Stack>
  )
}
